import { createTestIds } from '@pega/cosmos-react-core';
import { elements as formFieldTestIdElements } from '@pega/cosmos-react-core/lib/components/FormField/FormField.test-ids';

import { elements as toolbarTestIdElements } from './Toolbar/Toolbar.test-ids';

export const elements = ['iframe'] as const;

export const getEditorTestIds = createTestIds('editor', [
  ...elements,
  ...toolbarTestIdElements,
  ...formFieldTestIdElements
] as const);
